import { z } from 'zod';

export const previewTitleChangeRequestSchema = z.object({
  title: z.string().min(1),
});

export type IPreviewTitleChangeRequest = z.infer<typeof previewTitleChangeRequestSchema>;
